import React, { useMemo } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import SimpleTableTable from '../../../../../../../Components/SimpleTableTable'
import { AmbassadorSection } from '../../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../../Components/Section/SectionTitle'
import { COUNTRY_CODE } from '../../../../../../../constants'

const LegalDocumentsSection = ({
  documentAgreementContract,
  signedLegalDocuments,
  formW9,
  gpsAgreement,
  timezone,
  countryCode,
}) => {
  const data = useMemo(() => {
    const formattedSignedDocuments = signedLegalDocuments.map(dto => ({
      'Name': dto.name,
      'URL': dto.url,
      'Signed On': dto.dateTime,
    }))

    if (formW9 && formW9.fileName) {
      const formattedW9Form = {
        'Name': 'W9 Form',
        'URL': formW9.fileName,
        'Signed On': formW9.fileSaveTime,
      }
      formattedSignedDocuments.push(formattedW9Form)
    }
    if (gpsAgreement && gpsAgreement.signedAt) {
      const formattedGPSAgreement = {
        'Name': 'GPS tracking agreement',
        'URL': gpsAgreement.url,
        'Signed On': gpsAgreement.signedAt,
      }
      formattedSignedDocuments.push(formattedGPSAgreement)
    }
    if (documentAgreementContract && countryCode == COUNTRY_CODE.GERMANY) {
      const formattedAgreement = {
        'Name': 'Data acknowledgement',
        'URL': documentAgreementContract.url,
        'Signed On': documentAgreementContract.createdAt,
      }
      formattedSignedDocuments.push(formattedAgreement)
    }

    return formattedSignedDocuments
  }, [signedLegalDocuments, formW9, gpsAgreement, documentAgreementContract])

  return (
    <AmbassadorSection className="no-padding">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Signed Documents</SectionTitle>
          </Col>
        </Row>
        <Row className="padding-row">
          <Col xs={12}>
            <div
              className="signed-documents-table"
              cypress_id={'signedDocsTableWrapper'}
            >
              <SimpleTableTable
                header={['Name', 'URL', 'Signed On']}
                data={data}
                sortOn={['Name', 'Signed On']}
                postRowRender={m => ({
                  ...m,
                  'URL': (
                    <a href={m['URL']} target="_blank" rel="noreferrer">
                      {m['URL']}
                    </a>
                  ),
                  'Signed On': dateTimeFmt(m['Signed On'], timezone),
                })}
                showPages={false}
                cypress_id={'signedDocumentsTable'}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

function dateTimeFmt(unknownStamp, timeZone) {
  let stringOrStamp = Number(unknownStamp)
  if (Number.isNaN(stringOrStamp)) {
    stringOrStamp = unknownStamp
  }

  const parsed = new Date(stringOrStamp).toLocaleString(undefined, {
    timeZone,
    timeZoneName: 'short',
  })

  return parsed
}

export default LegalDocumentsSection
